import {useSliceDialogsWithActions} from "../../../../../newShared/hooks/useSliceDialogsWithActions";
import {dialogs, trainingsSlice} from "../../store/slice";

const slice = trainingsSlice;
export const useTrainingsDialogs = () => useSliceDialogsWithActions(slice.actions, dialogs);